const TOKEN_KEY = "scheduleAssistToken";
const USER_ID_KEY = "scheduleAssistUserId";

export function setScheduleAuthSession(token, userId) {
  if (token) {
    sessionStorage.setItem(TOKEN_KEY, token);
  }
  if (userId) {
    sessionStorage.setItem(USER_ID_KEY, String(userId));
  }
}

export function getScheduleAuthToken() {
  return sessionStorage.getItem(TOKEN_KEY) || "";
}

export function getScheduleAuthUserId() {
  return sessionStorage.getItem(USER_ID_KEY) || "";
}

export function setScheduleAuthUserId(userId) {
  if (userId) {
    sessionStorage.setItem(USER_ID_KEY, String(userId));
  }
}

export function clearScheduleAuthSession() {
  sessionStorage.removeItem(TOKEN_KEY);
  sessionStorage.removeItem(USER_ID_KEY);
}